(() => {
const mounted=new WeakSet();
function parseChart(value){return String(value||'').split(/\r?\n/).map(row=>row.split('|')).filter(v=>v.length===5&&!Number.isNaN(Number(v[4]))).map(v=>({us:v[0],uk:v[1],eu:v[2],jp:v[3],cm:Number(v[4])}));}
function init(root){if(mounted.has(root))return;mounted.add(root);const cfg=JSON.parse(document.querySelector('[data-pv-settings="'+root.dataset.pvSection+'"]').textContent);

(function(){
  if (!root) return;

  
  var mainImg = root.querySelector('.pf-media-main-img');
  var mainBox = root.querySelector('.pf-media-main');
  var thumbsTrack = root.querySelector('.pf-media-thumbs');
  var navNext = root.querySelector('.pf-media-nav--next');
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('.pf-thumb'));
  var currentIdx = 0;

  function showImg(i){
    if (!thumbs.length) return;
    if (i < 0) i = thumbs.length - 1;
    if (i >= thumbs.length) i = 0;
    currentIdx = i;
    var img = thumbs[i].querySelector('img');
    if (img && mainImg) mainImg.src = img.src.replace(/width=\d+/, 'width=1200');
    thumbs.forEach(function(b){b.removeAttribute('aria-current');});
    thumbs[i].setAttribute('aria-current','true');
    if (thumbsTrack){
      var t = thumbs[i], left = t.offsetLeft - thumbsTrack.offsetLeft, right = left + t.offsetWidth;
      if (left < thumbsTrack.scrollLeft) thumbsTrack.scrollTo({left: left, behavior: 'smooth'});
      else if (right > thumbsTrack.scrollLeft + thumbsTrack.clientWidth) thumbsTrack.scrollTo({left: right - thumbsTrack.clientWidth, behavior: 'smooth'});
    }
  }

  thumbs.forEach(function(btn, i){
    btn.addEventListener('click', function(){ showImg(i); });
  });

  if (navNext){
    navNext.addEventListener('click', function(){ showImg(currentIdx + 1); });
  }

  // Swipe support on main image
  if (mainBox && thumbs.length > 1){
    var startX = 0, startY = 0, deltaX = 0, deltaY = 0, isDown = false;
    mainBox.addEventListener('touchstart', function(e){
      isDown = true;
      startX = e.touches[0].clientX; startY = e.touches[0].clientY;
      deltaX = 0; deltaY = 0;
    }, {passive: true});
    mainBox.addEventListener('touchmove', function(e){
      if (!isDown) return;
      deltaX = e.touches[0].clientX - startX;
      deltaY = e.touches[0].clientY - startY;
    }, {passive: true});
    mainBox.addEventListener('touchend', function(){
      if (!isDown) return; isDown = false;
      
      if (Math.abs(deltaX) > 40 && Math.abs(deltaX) > Math.abs(deltaY) * 1.5){
        if (deltaX < 0) showImg(currentIdx + 1);
        else showImg(currentIdx - 1);
      }
    });
  }

  
  var prodScript = document.querySelector('[data-pf-product-'+root.dataset.pvSection+']');
  var product = null;
  if (prodScript){
    try { product = JSON.parse(prodScript.textContent); } catch(e){ product = null; }
  }
  if (product && product.variants && product.variants.length > 0){
    var idInput = root.querySelector('[data-pf-variant-id]');
    var atcText = root.querySelector('[data-pf-atc-text]');
    var atcBtn = root.querySelector('[data-pf-atc]');
    var priceCur = root.querySelector('[data-pf-price]');
    var priceOld = root.querySelector('[data-pf-price-old]');
    var currency = root.dataset.pvCurrency;

    function fmtMoney(cents){
      try { return (cents/100).toLocaleString('es-ES',{style:'currency', currency: currency, minimumFractionDigits: 2}); }
      catch(e){ return (cents/100).toFixed(2).replace('.', ',') + ' ' + currency; }
    }

    function getSel(){
      var inputs = root.querySelectorAll('[data-pf-option-input]');
      var sel = {};
      inputs.forEach(function(i){ if (i.checked) sel[i.getAttribute('data-pf-option-input')] = i.value; });
      return sel;
    }

    function findVariant(sel){
      var optNames = (product.options || []).map(function(o){return typeof o === 'string' ? o : o.name;});
      return product.variants.find(function(v){
        var opts = [v.option1, v.option2, v.option3];
        for (var i=0; i<optNames.length; i++){
          if (sel[optNames[i]] && sel[optNames[i]] !== opts[i]) return false;
        }
        return true;
      });
    }

    function update(){
      var sel = getSel();
      Object.keys(sel).forEach(function(name){
        var lbls = root.querySelectorAll('[data-pf-option-selected]');
        lbls.forEach(function(lbl){ if (lbl.getAttribute('data-pf-option-selected') === name) lbl.textContent = sel[name]; });
      });
      var v = findVariant(sel);
      if (!v){ if (idInput) { idInput.value = ''; idInput.disabled = true; } if (atcBtn) atcBtn.disabled = true; if (atcText) atcText.textContent = cfg.unavailable_label; return; }
      if (v){
        if (idInput) idInput.disabled = false;
        if (idInput) idInput.value = v.id;
        if (priceCur) priceCur.textContent = fmtMoney(v.price);
        if (priceOld){
          if (v.compare_at_price && v.compare_at_price > v.price){
            priceOld.textContent = fmtMoney(v.compare_at_price);
            priceOld.style.display = '';
          } else {
            priceOld.style.display = 'none';
          }
        }
        if (atcBtn){
          if (v.available){ atcBtn.disabled = false; if (atcText) atcText.textContent = cfg.add_label; }
          else { atcBtn.disabled = true; if (atcText) atcText.textContent = cfg.soldout_label; }
        }
      }
    }
    root.querySelectorAll('[data-pf-option-input]').forEach(function(i){ i.addEventListener('change', function(){ update(); markSoldOut(); }); });

    
    function markSoldOut(){
      if (!product || !product.variants) return;
      var sel = getSel();
      var optNames = (product.options || []).map(function(o){return typeof o === 'string' ? o : o.name;});
      // Find size option (last option typically, or the one named "Size")
      var sizeOptName = optNames.find(function(n){ return n.toLowerCase() === 'size' || n.toLowerCase() === 'tamanho' || n.toLowerCase() === 'talla'; });
      if (!sizeOptName) return;

      var sizeInputs = root.querySelectorAll('[data-pf-option-input="'+sizeOptName.replace(/"/g,'\\"')+'"]');
      var firstAvail = null;
      var currentSoldOut = false;

      sizeInputs.forEach(function(input){
        var label = root.querySelector('label[for="'+input.id+'"]');
        if (!label) return;
        var sizeValue = input.value;

        var isAvail = product.variants.some(function(v){
          var opts = [v.option1, v.option2, v.option3];
          // Match this size in the right position
          var sizeIdx = optNames.indexOf(sizeOptName);
          if (opts[sizeIdx] !== sizeValue) return false;
          if (!v.available) return false;
          // Check other selected options match
          for (var i=0; i<optNames.length; i++){
            if (i === sizeIdx) continue;
            if (sel[optNames[i]] && opts[i] !== sel[optNames[i]]) return false;
          }
          return true;
        });

        if (!isAvail){
          label.classList.add('pf-soldout');
          input.disabled = true;
          if (input.checked) currentSoldOut = true;
        } else {
          label.classList.remove('pf-soldout');
          input.disabled = false;
          if (!firstAvail) firstAvail = input;
        }
      });

      if (currentSoldOut && firstAvail){
        firstAvail.checked = true;
        firstAvail.dispatchEvent(new Event('change', {bubbles: true}));
      }
    }

    update();
    markSoldOut();
  }

  
  var shipDate = root.querySelector('[data-pf-ship-date]');
  if (shipDate){
    function addBiz(d, n){var r=new Date(d), a=0; while(a<n){r.setDate(r.getDate()+1); if(r.getDay()!==0 && r.getDay()!==6)a++;} return r;}
    var sd = addBiz(new Date(), 1);
    shipDate.textContent = sd.toLocaleDateString('es-ES',{weekday:'short',month:'short',day:'numeric'});
  }
})();


(function(){
  if (!root) return;
  var sg = root.querySelector('[data-pf-sg]');
  if (!sg) return;

  
  var MEN = parseChart(cfg.chart_men);

  var WOMEN = parseChart(cfg.chart_women);

  var state = { gender: 'WOMEN', system: 'US', unit: 'CM', index: null };
  var sizes = WOMEN;

  var genderGroup = sg.querySelector('[data-sg-group="gender"]');
  var sysGroup  = sg.querySelector('[data-sg-group="system"]');
  var unitGroup = sg.querySelector('[data-sg-group="unit"]');
  var sizesEl   = sg.querySelector('[data-sg-sizes]');
  var resultEl  = sg.querySelector('[data-sg-result]');
  var footEl    = sg.querySelector('[data-sg-foot]');
  var footUnit  = sg.querySelector('[data-sg-foot-unit]');
  var usEl      = sg.querySelector('[data-sg-us]');
  var ukEl      = sg.querySelector('[data-sg-uk]');
  var euEl      = sg.querySelector('[data-sg-eu]');
  var jpEl      = sg.querySelector('[data-sg-jp]');
  var emphEl    = sg.querySelector('[data-sg-us-emph]');

  function setActive(group, attr, value) {
    var btns = group.querySelectorAll('.pf-sg-chip');
    for (var i = 0; i < btns.length; i++) {
      btns[i].classList.toggle('is-active', btns[i].getAttribute(attr) === value);
    }
  }

  function renderSizes() {
    sizesEl.innerHTML = '';
    var key = state.system.toLowerCase();
    for (var i = 0; i < sizes.length; i++) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'pf-sg-chip';
      btn.setAttribute('data-idx', i);
      btn.textContent = sizes[i][key];
      if (i === state.index) btn.classList.add('is-active');
      sizesEl.appendChild(btn);
    }
  }

  function renderResult() {
    if (state.index === null) { resultEl.hidden = true; return; }
    var s = sizes[state.index];
    var val = (state.unit === 'CM' ? s.cm : s.cm / 2.54).toFixed(1).replace('.', ',');
    footEl.textContent  = val;
    footUnit.textContent = state.unit;
    usEl.textContent = s.us;
    ukEl.textContent = s.uk;
    euEl.textContent = s.eu;
    jpEl.textContent = s.jp;
    emphEl.textContent = 'US ' + s.us;
    resultEl.hidden = false;
  }

  genderGroup.addEventListener('click', function(e){
    var btn = e.target.closest('.pf-sg-chip');
    if (!btn) return;
    state.gender = btn.getAttribute('data-gender');
    sizes = state.gender === 'MEN' ? MEN : WOMEN;
    setActive(genderGroup, 'data-gender', state.gender);
    state.index = null;
    renderSizes();
    renderResult();
  });

  sysGroup.addEventListener('click', function(e){
    var btn = e.target.closest('.pf-sg-chip');
    if (!btn) return;
    state.system = btn.getAttribute('data-sys');
    setActive(sysGroup, 'data-sys', state.system);
    renderSizes();
  });

  unitGroup.addEventListener('click', function(e){
    var btn = e.target.closest('.pf-sg-chip');
    if (!btn) return;
    state.unit = btn.getAttribute('data-unit');
    setActive(unitGroup, 'data-unit', state.unit);
    renderResult();
  });

  sizesEl.addEventListener('click', function(e){
    var btn = e.target.closest('.pf-sg-chip');
    if (!btn) return;
    state.index = parseInt(btn.getAttribute('data-idx'), 10);
    var btns = sizesEl.querySelectorAll('.pf-sg-chip');
    for (var i = 0; i < btns.length; i++) btns[i].classList.toggle('is-active', i === state.index);
    renderResult();
  });

  
  function genderFromVariant(){
    var inputs = root.querySelectorAll('[data-pf-option-input]');
    for (var i = 0; i < inputs.length; i++){
      var name = (inputs[i].getAttribute('data-pf-option-input') || '').toLowerCase();
      if (name !== 'gender' || !inputs[i].checked) continue;
      var v = (inputs[i].value || '').trim().toUpperCase();
      if (v === 'MEN' || v === 'WOMEN') return v;
    }
    return null;
  }

  function syncGender(){
    var g = genderFromVariant();
    if (!g || g === state.gender) return;
    state.gender = g;
    sizes = g === 'MEN' ? MEN : WOMEN;
    setActive(genderGroup, 'data-gender', g);
    state.index = null;
    renderSizes();
    renderResult();
  }

  var sgDetails = sg.closest('details');
  if (sgDetails) sgDetails.addEventListener('toggle', function(){ if (sgDetails.open) syncGender(); });

  syncGender();
  renderSizes();
})();

 root.querySelectorAll('[data-pf-scroll-reviews]').forEach(link=>{const go=()=>document.querySelector('[data-pf-tp]')?.scrollIntoView({behavior:'smooth'});link.addEventListener('click',go);link.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();go();}});});
}
function scan(scope){scope.querySelectorAll('[data-pv-product]').forEach(init);}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>scan(document));else scan(document);
document.addEventListener('shopify:section:load',e=>scan(e.target));
})();
